export const BILLINGS_API_NAME = 'billings';
export const AWS_RECOMMENDATIONS_ROOT = '/api/v1/recommendations';
